import React from 'react'
import MaterialSymbol from '../material-symbol'

const GpsFixed = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="gps_fixed" {...props} />
))

GpsFixed.displayName = 'GpsFixed'

export default GpsFixed
